import { render, staticRenderFns } from "./FormSwitchItem.vue?vue&type=template&id=32de624a&scoped=true&"
import script from "./FormSwitchItem.vue?vue&type=script&lang=js&"
export * from "./FormSwitchItem.vue?vue&type=script&lang=js&"
import style0 from "./FormSwitchItem.vue?vue&type=style&index=0&id=32de624a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de624a",
  null
  
)

export default component.exports